export function getBuiltinVersions() {
  return {
    FORC: '0.51.1',
    FUEL_CORE: '0.22.1',
    FUELS: '0.76.0',
  };
}
